if (!customElements.get('quickbuy-variant-radios')) {
  class QuickbuyVariantRadios extends VariantSelects {
    constructor() {
      super();
      this.dataset.updateUrl = false;
      this.dataset.updateSwatch = false;
      this.dataset.updateVariantTitle = false;
    }

    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;

      const mediaSelector = `[data-media-id="${this.currentVariant.featured_media.id}"]`

      const newMedia = this
        .closest('.card-wrapper')
        .querySelector('.product-card__media-gallery')
        .querySelectorAll(mediaSelector);

      if (this.dataset.updateVariantTitle) {
        let variantTitle = this.querySelector('#variant-title')
        variantTitle.innerText = `in ${this.currentVariant.title}`
      }

      if (!newMedia) return;
      newMedia.forEach((media) => {
        const parent = media.parentElement;

        // move variant featured image to top
        parent.prepend(media);

        // make new featured variant image the active image
        media.classList.add('active')

        // update variant hover image
        // this.hoverImageWrapper = media.parentElement.querySelector('.product-card__hover-image img')

        // if (media.hasAttribute('data-hover-image')) {
        //   this.hoverImageWrapper.src = media.dataset.hoverImage;
        // }
      });
    }

    renderProductInfo() {}

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    }

    updateVariantInput() {
      const productForms = document.querySelectorAll(`#${this.dataset.productFormId}, #product-form-installment`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  }

  customElements.define('quickbuy-variant-radios', QuickbuyVariantRadios);
}
